<template>
    <div>
        <modal-crear-editar :configuracion="configuracion_modal" @realizado="restablecer_inputs"></modal-crear-editar>
        <tablita @cargar="cargar($event)" @cargar_url="cargar_url($event)" @editar="editar" @guardar="guardar($event)" :configuracion="configuracion_tabla">
          <template slot="alert">
            <div :class="`alert ${alert_clase} alert-dismissible fade show`" role="alert" v-if="alert">
                <span class="alert-icon"><i :class="alert_icono"></i></span>
                <span class="alert-text"><strong>{{alert_mensaje}}</strong></span>
                <ul>
                  <li class="" v-for="(e,idx) in alert_errores" :key="idx">
                    {{e}}
                  </li>
                </ul>
                <button type="button" class="close" @click="alert = !alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
          </template>
        </tablita>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ModalCrearEditar from '../../components/Modal/ModalEditarCrear'
import Tabla from '../../components/Tabla/Tabla'
//import lenguaje from '../../config/es_datatable.json'
export default {
    data:()=>({
        filter:'',
        columnas:[
          {key:'fecha_hora_inicio',label:'Fecha Inicio',busqueda:'',tipo:'datetime',searchable:true,path:'fecha_hora_inicio'},
          {key:'fecha_hora_fin',label:'Fecha Fin',busqueda:'',tipo:'datetime',searchable:true,path:'fecha_hora_fin'},

          {key:'cantidad_real',label:'Cantidad Descargada (kg)',busqueda:'',tipo:'number',searchable:false,path:'cantidad_real'},
          {key:'saldo_pozo',label:'Saldo Pozo (kg)',busqueda:'',tipo:'number',searchable:false,path:'saldo_pozo'},

        ],
        botones:[
          {label:'Editar',clase:'btn-warning',evento:'editar',icono:'fa fa-pen'}
        ],
        lista:[],
        links:[],
        inputs:[
          {cols:4,tipo:'numero',key:'saldo_pozo',valor:'',label:'Saldo Pozo (*)'},
          //{cols:4,tipo:'select',key:'ciclo_ticket',valor:'',label:'Ciclo ticket (*)',opciones:[],valor_opcion:'id',label_opcion:'nombre'}
        ],
        configuracion_modal:{
          titulo:'',
          ancho:'xl',
          ruta:'/guias',
          tipo_ruta:'post',
          titulo_boton:'Crear',
          clase_boton:'btn-success'
        },
        configuracion_tabla:{
          titulo:'SALDOS DE POZO',
          titulo_boton:'',
          clase_boton:'',
          btn_nuevo:false
        },
        pagina_actual:'',
        pozos:[],
        alert:false,
        alert_mensaje:'',
        alert_clase:'',
        alert_icono:'',
        alert_errores:[]
    }),
    mounted() {
        this.cargar_pozos();
    },
    methods: {
        async cargar_pozos(){
          await this.axios.get(`${this.api}/pozos?limit=9999999`,this.cabeceras_json).then((res)=>{
            this.pozos = res.data.data.data;
            //this.$set(this.columnas[7],'opciones',this.pozos);
            //this.$set(this.inputs[2],'opciones',this.ciclos_ticket);
            ////console.log('tickets',res.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
          this.cargar('?');
        },

        async cargar($event){
          //console.log('cargando',$event);
          if(!$event.includes('&tipo=2')){
            $event+='&tipo=2'; // 1,2,3,4 corresponde a Destinos de Proceso
          }
          //$event = $event.replace('?','?destino=5');
          this.pagina_actual = `${this.api}/movimiento_pozos${$event}`;
          this.lista = [];
            await this.axios.get(`${this.api}/movimiento_pozos${$event}`,this.cabeceras_json).then((res)=>{
                this.lista = res.data.data.data;
                this.links = res.data.data.links;
                /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
                this.inicializar_tabla({
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links,
                  botones:this.botones
                });
                this.$emit('generar',this.columnas,this.lista);
                ////console.log('listado',res.data.data.data);
                //$('#empresas').DataTable().draw();
            }).catch(e=>{
                //alert(e);
            })
        },
        async cargar_url(url){
          if(url){
            this.pagina_actual = url;
            await this.axios.get(url,this.cabeceras_json).then((res)=>{
                this.lista = res.data.data.data;
                this.links = res.data.data.links;
                ////console.log('listado',res.data.data.data);
                this.setear_lista({lista:this.lista,links:this.links});
                //$('#empresas').DataTable().draw();
            }).catch(e=>{
                //console.log(e);
            })
          }
          
        },

        async guardar($event){
          let id = $event.item.guia_distribucion_id;
          let body = {
            id:id,
            pozos_id:$event.item.pozos_id,
            fecha_hora_pozo_texto:$event.item.fecha_hora_pozo_texto
          }

          await this.axios.post(`${this.api}/guia_distribucion/${id}/enviar_a_pozo`,body,this.cabeceras_json).then((res)=>{
            //console.log('enviado a pozo',res.data);
            if(res.data.success){
              this.alert_clase = 'alert-success';
              this.alert_icono = 'fas fa-check-circle'
            }else{
              this.alert_clase = 'alert-danger';
              this.alert_errores = res.data.errores;
              this.alert_icono = 'fas fa-exclamation-circle';
            }
            this.alert_mensaje = res.data.mensaje;
            this.alert = true;
          }).catch((e)=>{
            //console.log(e);
          })
            //console.log('guardando',$event);
        },
        
        restablecer_inputs(){
          this.cargar_url(this.pagina_actual);
          this.inputs.forEach(i => {
            i.valor = '';
          });
          this.setear_inputs(this.inputs);
        },

        editar(evento){
          //console.log('evento',evento);
          let item = evento.item;
          this.inputs.forEach(i => {
            //recorrido del objeto a editar
              Object.keys(item).forEach(key => {
                  let valor = item[key];
                  if(i.key == key){
                      i.valor = valor;
                  }
              });
          });
          this.setear_inputs(this.inputs);
          this.configuracion_modal.ruta = `/movimiento_pozos/${evento.item.id}`;
          this.configuracion_modal.tipo_ruta = 'put';
          this.configuracion_modal.titulo_boton = 'Actualizar';
          this.configuracion_modal.clase_boton = 'btn-warning';

          this.$emit('abrir');
        },

        /* ver_documento(event){
          window.open(`${event.item.url}`, '_blank');
        }, */
        ...mapActions(['inicializar_tabla','setear_lista','setear_inputs'])
    },
    components:{
        'modal-crear-editar':ModalCrearEditar,
        'tablita':Tabla
    },
    computed:{
        ...mapState(['api','api_public','cabeceras_json']),
        query(){
          let string = '?';
          let and = '';
          let total = this.columnas.length - 1;
          this.columnas.forEach((c,index) => {
            if(index > 0 && string.length>0){
              and = '&';
            }else if(index == total){
              and = '';
            }

            if(c.busqueda != ''){
              string += `${and}${c.key}=${c.busqueda}`;
            }
          });
          return string;
        },

        
    }
}
</script>
<style>
  .form-control{
    height: calc(1em + 1.25rem + 5px);
  }
</style>